module.exports = {
	acl(user, defineAbility) {
		const ability = defineAbility((can, cannot) => {
			if (user.role === 'admin') {
				can('manage', 'Dropdown');
			} else {
				cannot('manage', 'Dropdown');
				can('read', 'Dropdown');
			}
		});

		return { ability };
	}
};
